import React from 'react';
import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import styled from '@emotion/styled';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { RJSFSchema } from '@rjsf/utils';
import Lost from '@/components/_common/Draw/Lost';

type JobMetadataProps = {
  schema: RJSFSchema;
};

const JobMetadata = ({ schema }: JobMetadataProps) => {
  const hasSchema = doesSchemaExist(schema);

  return (
    <Card elevation={0}>
      <CardContent>
        {hasSchema ? (
          <SchemaForm schema={schema} />
        ) : (
          <Grid container justifyContent="center" alignItems="center" flexDirection="column" sx={{ p: 4 }}>
            <Illustration>
              <Lost />
            </Illustration>
            <ErrorMessage variant="subtitle2">No additional info</ErrorMessage>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default JobMetadata;

function doesSchemaExist(schema: RJSFSchema) {
  return schema && schema.properties && JSON.stringify(schema.properties) !== '{}';
}

const ErrorMessage = styled(Typography)`
  margin-bottom: 10px;
  opacity: 0.8;
`;

const Illustration = styled.div`
  max-width: 200px;
  svg {
    width: 100%;
    height: auto;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;
